import { Box, Card, Heading, Paragraph } from '@zillow/constellation-10';

import { SpotIllustration } from '@zg-rentals/visual-cohesion';

import type { SpotIllustrationName } from '@zg-rentals/visual-cohesion';

type CardConfig = {
  title: string;
  description: string;
  illustration: SpotIllustrationName;
};

const cardsConfig: Array<CardConfig> = [
  {
    illustration: 'multi-family-building',
    title: 'Enhance visibility',
    description: 'Easily turn unadvertised properties into rich media listings on Zillow and HotPads',
  },
  {
    illustration: 'rental-notifications',
    title: 'Manage seamlessly',
    description: 'Once claimed, listings stay accurate and hassle-free thanks to feed-enabled updates',
  },
  {
    illustration: 'rental-search',
    title: 'Get serious leads',
    description: 'Receive HotPads leads right in your inbox from renters searching for your properties',
  },
  {
    illustration: 'rental-listing',
    title: 'Stay future-ready',
    description: 'Get your properties ready for up to 20x more exposure* powered by flexible ad options',
  },
];

export const ClaimYourListingDetails = ({ isFromModal = false }: { isFromModal?: boolean }) => (
  <>
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: {
          base: 'repeat(2, minmax(0, 1fr))',
          xl: isFromModal ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
        },
        gridAutoRows: '1fr',
        gap: '400',
      }}
    >
      {cardsConfig.map((card) => (
        <Card tone="neutral" key={card.title} css={{ padding: '600' }}>
          <SpotIllustration name={card.illustration} />
          <Heading
            textStyle="heading-sm"
            level={6}
            css={{
              overflowWrap: 'break-word',
              marginBlock: '400',
            }}
          >
            {card.title}
          </Heading>
          <Paragraph
            textStyle="body"
            css={{
              overflowWrap: 'break-word',
            }}
          >
            {card.description}
          </Paragraph>
        </Card>
      ))}
    </Box>
    <Paragraph textStyle="body-xs" css={{ marginTop: 'md', fontStyle: 'italic' }}>
      *Zillow Internal Data. Multifamily claimed listing performance. Total Impressions. May-June 2025.
    </Paragraph>
  </>
);

export default ClaimYourListingDetails;
